export const CARD_CLASS = 'card';
export const MODAL_OVERLAY_CLASS = 'fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50';
export const MODAL_CONTENT_CLASS = 'bg-white rounded-lg p-6 max-w-4xl w-full';
